import { render } from "./StorageContainerDropdown.vue?vue&type=template&id=52941467"
import script from "./StorageContainerDropdown.vue?vue&type=script&lang=js"
export * from "./StorageContainerDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__